import { useState } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";


export const RegisterCards = () => {
   const cards = [
      {
         name: "High Level Networking",
         img: "./assets/media/networking-e1553444570205 1 (1).png",
         content: (
            <div
               style={{ display: "flex", flexDirection: "column", gap: "27.5px" }}
            >
               <div>Connect with investors, startups and potential partners.</div>
               <div>PRE-REGISTRATION SAVINGS $300 OFF</div>
            </div>
         ),
         btnTxt: "Register now",
         btnLink: "https://youngstartup.com/upcoming",
      },
      {
         name: "Venture Panels",
         img: "./assets/media/venturePanels-e1553444309249 1.png",
         content:
            "Hear top tier VCs, Corporate VCs and Angel Investors on the key issues facing Investors and Startup CEOs alike. Industry experts will provide updated analyses and share their experience with the audience.",
         btnTxt: "Apply to speak",
         btnLink: "https://youngstartup.com/speak",
      },
      {
         name: "Company Presentations",
         img: "./assets/media/presentations-e1553445156295 1.png",
         content:
            "Discover more than 100 of the hottest early stage and emerging growth technology, mobile, life sciences, healthcare IT, clean-tech and ed-tech innovators as they present live to leading investors.",
         btnTxt: "Apply to present",
         btnLink: "https://youngstartup.com/upcoming",
      },
   ];

   const Card = ({ card }) => {
      const [chevron, setChevron] = useState(0);
      const [margin1, setMargin1] = useState("0vw");

      return (
         <Paper
            elevation={20}
            sx={{
               display: "flex",
               flexDirection: "column",
               justifyContent: "center",
               gap: "15px",
               padding: "2.5%",
               flex: 1,
               alignItems: "stretch",
               m: window.innerWidth < 800 && 5,
            }}
         >
            <img
               alt='card'
               src={card.img}
               style={{ maxWidth: "100%", height: "auto", margin: "auto", borderRadius: '10px' }}
            />
            <h2 style={{ textAlign: "center" }}>{card.name}</h2>
            <h5 style={{ textAlign: "center" }}>{card.content}</h5>
            <a href={card.btnLink} style={{ margin: "auto" }}>
               <Button
                  onMouseOver={(e) => {
                     setChevron(1);
                     setMargin1("1.5vw");
                  }}
                  onMouseLeave={() => {
                     setChevron(0);
                     setMargin1("0vw");
                  }}
                  className="dark-btn"
                  sx={{
                     fontWeight: "900",
                     backgroundColor: "#7C2387 !important",
                     color: "white",
                  }}
               >
                  <div style={{ display: "flex", alignItems: "center" }}>
                     <ChevronRightIcon sx={{ opacity: "0" }} />
                     <div>{card.btnTxt}</div>
                     <ChevronRightIcon
                        sx={{
                           transition: ".3s all ease-in-out",
                           opacity: chevron,
                           marginLeft: margin1,
                        }}
                     />
                  </div>
               </Button>
            </a>
         </Paper>
      );
   };
   return (
      <div
         style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "center",
            padding: "2.5%",
            backgroundColor: "#212529",
            paddingRight: window.innerWidth > 800 && '15%',
            paddingLeft: window.innerWidth > 800 && '15%'
         }}
      >
         <h2 style={{ margin: "auto", textAlign: "center", color: 'white' }}>
            This exclusive Venture Capital Summit will feature:
         </h2>
         <div
            style={{
               display: "flex",
               alignItems: "stretch",
               gap: window.innerWidth < 769 ? "15px" : "5%",
               padding: "2.5%",
               flexDirection: window.innerWidth < 769 && "column",
            }}
         >
            {cards.map((card, i) => {
               return <Card card={card} key={i} />;
            })}
         </div>
      </div>
   );
};
